import axios from "axios";

// Empty in production: web and api share an origin through the edge proxy,
// so the paths below stay relative. Falling back to a localhost URL here
// pointed the deployed bundle at the developer's own machine.
const API_URL = process.env.REACT_APP_API_BASE_URL || "";

const login = async (email, password) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/v2/auth/login`,
      { email, password },
      { 
        withCredentials: true,
        timeout: 10000 // 10 seconds timeout
      }
    );
    return response.data;
  } catch (error) {
    let errorMessage = 'An unexpected error occurred';
    
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      errorMessage = error.response.data?.message || 
                   error.response.data?.error || 
                   'Invalid credentials. Please try again.';
    } else if (error.request) {
      // The request was made but no response was received
      errorMessage = 'No response from server. Please check your connection.';
    } else if (error.code === 'ECONNABORTED') {
      errorMessage = 'Request timed out. Please try again.';
    } else if (error.message === 'Network Error') {
      errorMessage = 'Network error. Please check your internet connection.';
    }
    
    const errorToThrow = new Error(errorMessage);
    errorToThrow.name = 'AuthError';
    throw errorToThrow;
  }
};

// Fetch current user (verification)
const verify = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/v2/auth/me`, {
      withCredentials: true,
      timeout: 5000 // 5 seconds timeout for verify
    });
    return response.data;
  } catch (error) {
    // If unauthorized or network issues, surface a consistent shape
    return { success: false };
  }
};

const logout = async () => {
  try {
    const response = await axios.post(
      `${API_URL}/api/v2/auth/logout`,
      {},
      { 
        withCredentials: true,
        timeout: 5000 // 5 seconds timeout for logout
      }
    );
    return response.data;
  } catch (error) {
    // Even if logout fails on the server, we still want to proceed with client-side logout
    console.error('Logout error:', error);
    return { success: true }; // Assume success to allow the app to continue
  }
};

const authService = {
  login,
  logout,
  verify,
};

export default authService;
